import { Stack, IconButton, Popover, Card, OptionList } from "@introist/react-foundation/v2";
import { useMemo, useState } from "react";
import { AlignCenter, AlignLeft, AlignRight } from "lucide-react";

export const TextAlignSelector = ({
  onSelect,
  alignment = "left"
}: {
  onSelect: (alignment: string) => void;
  alignment?: string;
}) => {
  const [buttonRef, setButtonRef] = useState<HTMLElement | null>(null);
  const [open, setOpen] = useState(false);

  const activeIcon = useMemo(() => {
    if (alignment === "right") return <AlignRight size={16} />;
    if (alignment === "center") return <AlignCenter size={16} />;
    return <AlignLeft size={16} />;
  }, [alignment]);

  return (
    <>
      <Stack ref={setButtonRef}>
        <IconButton size="large" onClick={() => setOpen(true)} icon={activeIcon} />
      </Stack>

      <Popover
        referenceElement={buttonRef}
        open={open}
        onClose={() => setOpen(false)}
        closeOnContentClick={false}
      >
        <Card style={{ padding: 0 }} elevated>
          <OptionList
            options={[
              {
                key: "Left",
                startAdornment: <AlignLeft size={16} />,
                onClick: () => {
                  onSelect("left");
                }
              },
              {
                key: "Center",
                startAdornment: <AlignCenter size={16} />,
                onClick: () => {
                  onSelect("center");
                }
              },
              {
                key: "Right",
                startAdornment: <AlignRight size={16} />,
                onClick: () => {
                  onSelect("right");
                }
              }
            ]}
          />
        </Card>
      </Popover>
    </>
  );
};
